// 存放临时的定向、兴趣的store数据
import { ref } from '@vue/composition-api';

import { InterestBehavior, BehaviorTag } from '@tt4b/ttam-enums';
const state = {
  interestBehaviorList: ref<InterestBehavior[]>([]), // 兴趣列表
  videoBehaviorList: ref<BehaviorTag[]>([]), // 视频
  creatorBehaviorList: ref<BehaviorTag[]>([]), // 创作者
  interestBehaviorListParams: ref<number[]>([]),
  interestList: ref<BehaviorTag[]>([]),
};
const mutations = {
  setInterestBehaviorList(list: InterestBehavior[]) {
    state.interestBehaviorList.value = list;
  },
  setVideoBehaviorList(list: BehaviorTag[]) {
    state.videoBehaviorList.value = list;
  },
  setCreatorBehaviorList(list: BehaviorTag[]) {
    state.creatorBehaviorList.value = list;
  },
  setInterestBehaviorListParams(list: number[]) {
    state.interestBehaviorListParams.value = list;
  },
  setInterestList(list: BehaviorTag[]) {
    state.interestList.value = list;
  },
};

export default {
  state,
  mutations,
};
